// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2b-0";